import { URL_API } from '../../../../services/api_url'
import { useAxiosHttpClient } from '../../../../hooks/useAxiosHttpClient'
import { RemoteGetComprehensiveReports } from '../../../../data/usecases/Reports/RemoteGetComprehensiveReports'
import Reports from '../../../../pages/Reports'

export const ReportsFactory = () => {
  const URL = URL_API || 'without-url'
  const axiosHttpClient = useAxiosHttpClient()
  const remoteGetComprehensiveReports = new RemoteGetComprehensiveReports(
    URL,
    axiosHttpClient
  )

  return (
    <Reports remoteGetComprehensiveReports={remoteGetComprehensiveReports} />
  )
}
